import React, { Component } from 'react'
import './styles.scss'
import minus from './assets/minus.svg'
import plus from './assets/plus.svg'
import Switcher from '../../../components/switcher'
import connector from 'src/decorators/connector'
import { IStoresMap } from 'src/types'
import cart from './assets/cart.svg'

class AnshlagFull extends Component<ReturnType<typeof storesToProps>> {

    public state = {
        backgroundColor: "#3C63AB",
        fontColor: "white",
        type: 0,
        plateType: 1,
        showConfig: true,
        streetName: "Юбилейная",
        streetType: "улица",
        houseNumber: 18,
        counter: 1,
        plates: {},
        "0": {
            name: "Адресная табличка 100х25 см",
            id: "1",
            price: 5000,
            size: "100х25 см",
            priceComposit: 1000,
            priceLigth: 3000
        },
        "1": {
            name: "Адресная табличка c номером дома 100х25 см",
            id: "2",
            price: 5000,
            size: "100х25 см",
            priceComposit: 1000,
            priceLigth: 3000
        },
        "2": {
            name: "Адресная табличка c отдельным номером дома 100х25 см",
            id: "3",
            price: 7000,
            size: "100 х 25 см + 25 х 25 см",
            priceComposit: 1000,
            priceLigth: 3000
        },
        "3": {
            name: "Yомером дома 25х25 см",
            id: "4",
            price: 3000,
            size: "25 х 25 см",
            priceComposit: 272,
            priceLigth: 3000
        }
    }


    componentDidMount() {
        const element = document.getElementById('anshlag');
        let googds = element?.textContent || element?.innerText;
        const n = googds?.lastIndexOf(",") as number;
        googds = googds?.substring(0, n) as string + googds?.substring(n + 1);
        const json = JSON.parse(googds as string)
        this.setState({ '0': { ...json.anshlag[0], priceComposit: 1000, priceLigth: 5990 } })
        this.setState({ '1': { ...json.anshlag[1], priceComposit: 1000, priceLigth: 5990 } })
        this.setState({ '3': { ...json.anshlag[2], priceComposit: 272, priceLigth: 1990 } })
    }



    public onPlusCounter = () => {
        this.setState({ counter: this.state.counter + 1 })
    }

    public onMinusCounter = () => {
        if (this.state.counter > 1) {
            this.setState({ counter: this.state.counter - 1 })
        }
    }

    public onChangePlateType = (type: number) => {
        this.setState({ plateType: type })
    }

    public onChangeHouseNumber = (e: React.FormEvent<HTMLInputElement>) => {
        this.setState({ houseNumber: e.currentTarget.value })
    }
    public onChangeStreetName = (e: React.FormEvent<HTMLInputElement>) => {
        this.setState({ streetName: e.currentTarget.value })
    }

    public onChangeStreetType = (e: React.FormEvent<HTMLInputElement>) => {
        this.setState({ streetType: e.currentTarget.value })
    }

    public onChangeColor = (bgColor: string) => {
        if (bgColor !== "white") {
            this.setState({ backgroundColor: bgColor, fontColor: "white" })
        } else {
            this.setState({ backgroundColor: bgColor, fontColor: "black" })
        }
    }

    public onChangeType = (type: number) => {
        this.setState({ type })
    }

    public showConfigHundler = () => {
        this.setState({ showConfig: !this.state.showConfig })
    }

    get currentPlate() {
        if (this.state.plateType === 0) {
            return this.state[0]
        }
        if (this.state.plateType === 1) {
            return this.state[1]
        }
        if (this.state.plateType === 2) {
            return this.state[2]
        }
        if (this.state.plateType === 3) {
            return this.state[3]
        }
        return 0
    }
    get currentPaltePrice() {
        if (this.state.plateType === 0) {
            switch (this.state.type) {
                case 0:
                    return this.state[0].price
                case 1:
                    return this.state[0].priceComposit
                case 2:
                    return this.state[0].priceLigth
                default: return this.state[0].price
            }
        }
        if (this.state.plateType === 1) {
            switch (this.state.type) {
                case 0:
                    return this.state[1].price
                case 1:
                    return this.state[1].priceComposit
                case 2:
                    return this.state[1].priceLigth
                default: return this.state[1].price
            }
        }
        if (this.state.plateType === 2) {
            switch (this.state.type) {
                case 0:
                    return Number(this.state[0].price) + Number(this.state[3].price)
                case 1:
                    return Number(this.state[0].priceComposit) + Number(this.state[3].priceComposit)
                case 2:
                    return Number(this.state[0].priceLigth) + Number(this.state[3].priceLigth)
                default: return Number(this.state[0].price) + Number(this.state[3].price)
            }
        }
        if (this.state.plateType === 3) {
            switch (this.state.type) {
                case 0:
                    return this.state[3].price
                case 1:
                    return this.state[3].priceComposit
                case 2:
                    return this.state[3].priceLigth
                default: return this.state[3].price
            }
        }
        return 0
    }

    get currentPlateSize() {
        if (this.state.plateType === 0) {
            return "100 х 25 см"
        }
        if (this.state.plateType === 1) {
            return "100 х 25 см"
        }
        if (this.state.plateType === 2) {
            return "100 х 25 см + 25 х 25 см"
        }
        if (this.state.plateType === 3) {
            return "25 х 25 см"
        }
        return ""
    }

    get currentPlateMaterials() {
        if (this.state.type === 0) {
            return "ПВХ"
        }
        if (this.state.type === 1) {
            return "Композит"
        }
        if (this.state.type === 2) {
            return "С подсветкой"
        }
        return ""
    }

    get currentPlateColor() {
        switch (this.state.backgroundColor) {
            case "#3C63AB":
                return "синий"
            case "#1B9252":
                return "зеленый"
            case "#723B22":
                return "коричневый"
            case "white":
                return "белый"
        }
    }

    public toBusket = () => {
        const { addProduct } = this.props.busket
        const { plateType } = this.state
        if (plateType === 0) {
            addProduct(this.state[0], this.state.counter, 0, 0, `Цвет: ${this.currentPlateColor}, материал: ${this.currentPlateMaterials}, ${this.state.streetName} ${this.state.streetType} ${this.state.houseNumber}`)
        }
        if (plateType === 1) {
            addProduct(this.state[1], this.state.counter, 0, 0, `Цвет: ${this.currentPlateColor}, материал: ${this.currentPlateMaterials}, ${this.state.streetName} ${this.state.streetType} ${this.state.houseNumber}`)
        }
        if (plateType === 2) {
            addProduct(this.state[0], this.state.counter, 0, 0, `Цвет: ${this.currentPlateColor}, материал: ${this.currentPlateMaterials}, ${this.state.streetName} ${this.state.streetType} ${this.state.houseNumber}`)
            addProduct(this.state[3], this.state.counter, 0, 0, `Цвет: ${this.currentPlateColor}, материал: ${this.currentPlateMaterials}, ${this.state.streetName} ${this.state.streetType} ${this.state.houseNumber}`)
        }
        if (plateType === 3) {
            addProduct(this.state[3], this.state.counter, 0, 0, `Цвет: ${this.currentPlateColor}, материал: ${this.currentPlateMaterials}, ${this.state.streetName} ${this.state.streetType} ${this.state.houseNumber}`)
        }

        this.setState({ counter: 1 })
    }

    public addToResult = () => {
        const { addPlates } = this.props.anshlagStore
        const { addProduct } = this.props.busket
        const { backgroundColor } = this.state

        const { plateType } = this.state
        if (plateType === 0) {
            addPlates(this.state.counter,
                this.currentPlateSize,
                backgroundColor,
                this.currentPlateMaterials,
                'Адресная табличка',
                this.state[0],
                `Цвет: ${this.currentPlateColor}, материал: ${this.currentPlateMaterials}, ${this.state.streetName} ${this.state.streetType} ${this.state.houseNumber}`)
            // addProduct(this.state[0], this.state.counter, 0, 0, `Цвет: ${this.currentPlateColor}, материал: ${this.currentPlateMaterials}, ${this.state.streetName} ${this.state.streetType} ${this.state.houseNumber}`)
        }
        if (plateType === 1) {
            addPlates(this.state.counter, this.currentPlateSize, backgroundColor, this.currentPlateMaterials, 'Адресная табличка', this.state[1], `Цвет: ${this.currentPlateColor}, материал: ${this.currentPlateMaterials}, ${this.state.streetName} ${this.state.streetType} ${this.state.houseNumber}`)
            // addProduct(this.state[1], this.state.counter, 0, 0, `Цвет: ${this.currentPlateColor}, материал: ${this.currentPlateMaterials}, ${this.state.streetName} ${this.state.streetType} ${this.state.houseNumber}`)
        }
        if (plateType === 2) {
            addPlates(this.state.counter, this.currentPlateSize, backgroundColor, this.currentPlateMaterials, 'Адресная табличка', this.state[0], `Цвет: ${this.currentPlateColor}, материал: ${this.currentPlateMaterials}, ${this.state.streetName} ${this.state.streetType} ${this.state.houseNumber}`)
            addPlates(this.state.counter, this.currentPlateSize, backgroundColor, this.currentPlateMaterials, 'Адресная табличка', this.state[3], `Цвет: ${this.currentPlateColor}, материал: ${this.currentPlateMaterials}, ${this.state.streetName} ${this.state.streetType} ${this.state.houseNumber}`)
            // addProduct(this.state[0], this.state.counter, 0, 0, `Цвет: ${this.currentPlateColor}, материал: ${this.currentPlateMaterials}, ${this.state.streetName} ${this.state.streetType} ${this.state.houseNumber}`)
            // addProduct(this.state[3], this.state.counter, 0, 0, `Цвет: ${this.currentPlateColor}, материал: ${this.currentPlateMaterials}, ${this.state.streetName} ${this.state.streetType} ${this.state.houseNumber}`)
        }
        if (plateType === 3) {
            addPlates(this.state.counter, this.currentPlateSize, backgroundColor, this.currentPlateMaterials, 'Адресная табличка', this.state[3], `Цвет: ${this.currentPlateColor}, материал: ${this.currentPlateMaterials}, ${this.state.streetName} ${this.state.streetType} ${this.state.houseNumber}`)
            //addProduct(this.state[3], this.state.counter, 0, 0, `Цвет: ${this.currentPlateColor}, материал: ${this.currentPlateMaterials}, ${this.state.streetName} ${this.state.streetType} ${this.state.houseNumber}`)
        }

        this.setState({ counter: 1 })


        //addProduct(this.currentPlate, this.state.counter, 0,0, )
    }

    get fontSizeFor1and3() {
        if (this.state.streetName.length > 23 && this.state.streetName.length < 25) {
            return "font45"
        }
        if (this.state.streetName.length >= 25) {
            return "font43"
        }
        return ""
    }
    get fontSizeFor2() {
        if (this.state.streetName.length > 18 && this.state.streetName.length < 21) {
            return "font45"
        }
        if (this.state.streetName.length >= 21 && this.state.streetName.length < 24) {
            return "font40"
        }
        if (this.state.streetName.length >= 24) {
            return "font36"
        }
        return ""
    }

    public render() {
        const { backgroundColor, fontColor } = this.state

        return (
            <div id={"anshlag_full"} className="anshlag_full">
                <div className="switcher">
                    <div className="title">Адресная табличка</div>
                    <Switcher checked={this.state.showConfig} onClick={this.showConfigHundler} />
                </div>
                {this.state.showConfig && <>
                    <div className="type_swither">
                        <div onClick={() => this.onChangeType(0)} className={`item ${this.state.type === 0 && 'active'}`}>ПВХ</div>
                        <div onClick={() => this.onChangeType(1)} className={`item ${this.state.type === 1 && 'active'}`}>Композит</div>
                        <div onClick={() => this.onChangeType(2)} className={`item ${this.state.type === 2 && 'active'}`}>С подсветкой</div>
                    </div>
                    <div className={`plate_examples ${this.state.type === 2 ? "dop_light" : ""}`}>
                        <div className="plates_container">
                            <div onClick={() => this.onChangePlateType(0)} className={`plate_100x25_1 ${this.state.plateType === 0 ? "active" : ""}`}>
                                <div className="plate" style={
                                    {
                                        "backgroundColor": `${this.state.plateType === 0 ? this.state.backgroundColor : '#a1a19f'}`,
                                        "borderColor": this.state.fontColor
                                    }
                                }>
                                    <div className="plate_borders" style={{ "borderColor": `${this.state.plateType === 0 ? this.state.fontColor : 'white'}` }} >
                                    </div>
                                </div>
                            </div>
                            <div className={`plate_100x25_2 ${this.state.plateType === 1 ? "active" : ""}`} onClick={() => this.onChangePlateType(1)}>
                                <div className="plate" style={
                                    {
                                        "backgroundColor": `${this.state.plateType === 1 ? this.state.backgroundColor : '#a1a19f'}`,
                                        "borderColor": this.state.fontColor
                                    }
                                }>
                                    <div className="plate_borders" style={{ "borderColor": `${this.state.plateType === 1 ? this.state.fontColor : 'white'}` }} >
                                        <div className='street_name'>
                                        </div>
                                        <div className='number_house'></div>
                                    </div>
                                </div>
                            </div>
                            <div className={`plate_100x25_25x25 ${this.state.plateType === 2 ? "active" : ""}`} onClick={() => this.onChangePlateType(2)}>
                                <div className='plates'>
                                    <div className="plate" style={
                                        {
                                            "backgroundColor": `${this.state.plateType === 2 ? this.state.backgroundColor : '#a1a19f'}`,
                                            "borderColor": this.state.fontColor
                                        }}>
                                        <div className="plate_borders" style={{ "borderColor": `${this.state.plateType === 2 ? this.state.fontColor : 'white'}` }}>
                                        </div>
                                    </div>
                                    <div className='number_house' style={{ "backgroundColor": `${this.state.plateType === 2 ? this.state.backgroundColor : '#a1a19f'}` }}>
                                        <div className="plate_borders" style={{ "borderColor": `${this.state.plateType === 2 ? this.state.fontColor : 'white'}` }} ></div>
                                    </div>
                                </div>
                            </div>
                            <div className={`plate_25x25 ${this.state.plateType === 3 ? "active" : ""}`} onClick={() => this.onChangePlateType(3)}>
                                <div className='plates' style={
                                    {
                                        "backgroundColor": `${this.state.plateType === 3 ? this.state.backgroundColor : '#a1a19f'}`,
                                        "borderColor": this.state.fontColor
                                    }}>
                                    <div className='number_house' style={
                                        {
                                            "backgroundColor": `${this.state.plateType === 3 ? this.state.backgroundColor : '#a1a19f'}`,
                                            "borderColor": this.state.fontColor
                                        }}>
                                        <div className="plate_borders" style={{ "borderColor": `${this.state.plateType === 3 ? this.state.fontColor : 'white'}` }} ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="size">
                            {this.state.plateType === 0 && "100 х 25 см"}
                            {this.state.plateType === 1 && "100 х 25 см"}
                            {this.state.plateType === 2 && "100 х 25 см + 25 х 25 см"}
                            {this.state.plateType === 3 && "25 х 25 см"}

                        </div>
                        <div className="big_plate_block">
                            <div className={`plate_100x25_1 ${this.state.plateType === 0 ? "active" : ""} ${this.fontSizeFor1and3}`}>
                                <div className="plate" style={{ backgroundColor: this.state.backgroundColor, color: this.state.fontColor }}>
                                    <div className="plate_borders" style={{ color: this.state.fontColor, borderColor: this.state.fontColor }}>
                                        <div className={`name ${this.fontSizeFor1and3}`} style={{ color: this.state.fontColor, borderColor: this.state.fontColor }}>{this.state.streetName}</div>
                                        <div className="street" style={{ color: this.state.fontColor, borderColor: this.state.fontColor }}> {this.state.streetType} </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`plate_100x25_2 ${this.state.plateType === 1 ? "active" : ""}  ${this.fontSizeFor2}`}>
                                <div className="plate" style={{ backgroundColor: this.state.backgroundColor, color: this.state.fontColor }}>
                                    <div className="plate_borders" style={{ color: this.state.fontColor, borderColor: this.state.fontColor }}>
                                        <div className={"street_name"}>
                                            <div className={`name ${this.fontSizeFor2}`} style={{ color: this.state.fontColor, borderColor: this.state.fontColor }}>{this.state.streetName}</div>
                                            <div className="street" style={{ color: this.state.fontColor, borderColor: this.state.fontColor }}> {this.state.streetType} </div>
                                        </div>
                                        <div className={`number_house ${this.fontSizeFor2}`} style={{ borderColor: this.state.fontColor }}>
                                            {this.state.houseNumber}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`plate_100x25_25x25 ${this.state.plateType === 2 ? "active" : ""} ${this.fontSizeFor1and3}`}>
                                <div className="plates">
                                    <div className="plate" style={{ backgroundColor: this.state.backgroundColor, color: this.state.fontColor }}>
                                        <div className="plate_borders" style={{ color: this.state.fontColor, borderColor: this.state.fontColor }}>
                                            <div className={"street_name"}>
                                                <div className={`name ${this.fontSizeFor1and3}`} style={{ color: this.state.fontColor, borderColor: this.state.fontColor }}>{this.state.streetName}</div>
                                                <div className="street" style={{ color: this.state.fontColor, borderColor: this.state.fontColor }}> {this.state.streetType} </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="number_house" style={
                                        {
                                            backgroundColor: this.state.backgroundColor,
                                        }
                                    }>
                                        <div className="plate_borders" style={
                                            {
                                                color: this.state.fontColor,
                                                borderColor: this.state.fontColor
                                            }
                                        }>
                                            {this.state.houseNumber}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`plate_25x25 ${this.state.plateType === 3 ? "active" : ""}`}>
                                <div className='plates'>
                                    <div className="number_house" style={
                                        {
                                            backgroundColor: this.state.backgroundColor,
                                        }
                                    }>
                                        <div className="plate_borders" style={
                                            {
                                                color: this.state.fontColor,
                                                borderColor: this.state.fontColor
                                            }
                                        }>
                                            {this.state.houseNumber}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="colors_container">
                                <div className="colors">
                                    <div className={`_3C63AB ${this.state.backgroundColor === "#3C63AB" ? "active" : ""}`} onClick={() => this.onChangeColor('#3C63AB')} > <div /></div>
                                    <div className={`_1B9252 ${this.state.backgroundColor === "#1B9252" ? "active" : ""}`} onClick={() => this.onChangeColor('#1B9252')} ><div /></div>
                                    <div className={`_723B22 ${this.state.backgroundColor === "#723B22" ? "active" : ""}`} onClick={() => this.onChangeColor('#723B22')} ><div /></div>
                                    <div className={`white ${this.state.backgroundColor === "white" ? "active" : ""}`} onClick={() => this.onChangeColor('white')} ><div /></div>
                                </div>
                            </div>
                        </div>
                        <div className={"inputs_container"}>
                            {this.state.plateType !== 3 && <input id="namestreet" defaultValue={this.state.streetName} maxLength={25} onChange={this.onChangeStreetName} />}
                            {this.state.plateType !== 3 && <input id="typestreet" defaultValue={this.state.streetType} maxLength={25} onChange={this.onChangeStreetType} />}
                            {this.state.plateType !== 0 && <input id="numberhouse" defaultValue={this.state.houseNumber} maxLength={6} onChange={this.onChangeHouseNumber} />}
                        </div>
                    </div>
                    <div className={"counter"}>
                        <div className="minus" onClick={this.onMinusCounter}>
                            <img src={minus} />
                        </div>
                        <div className="count">{this.state.counter}</div>
                        <div className="plus" onClick={this.onPlusCounter}>
                            <img src={plus} />
                        </div>
                    </div>
                    <div className="summary">
                        <div className="cont">
                            <div className="title">Адресная табличка {this.state.plateType === 0 && "100 х 25 см"}
                                {this.state.plateType === 1 && "100 х 25 см"}
                                {this.state.plateType === 2 && "100 х 25 см + 25 х 25 см"}
                                {this.state.plateType === 3 && "25 х 25 см"}</div>
                            <div className="price">{this.currentPaltePrice * this.state.counter} руб.</div>
                        </div>
                        <div className="plus" onClick={this.toBusket}>
                            <img src={cart} />
                        </div>

                    </div>
                </>
                }

                {/*
                <div className="colors_container">
                    <div className="text">Цвет фона на выбор: </div>
                    <div className="colors">
                        <div className="_3C63AB" onClick={()=>this.onChangeColor('#3C63AB')}/>
                        <div className="_1B9252" onClick={()=>this.onChangeColor('#1B9252')}/>
                        <div className="_723B22" onClick={()=>this.onChangeColor('#723B22')}/>
                        <div className="white" onClick={()=>this.onChangeColor('white')}/>
                    </div>
                </div>
                <div className="order_ancor">
                    Заказать адресную табличку
                    <div className="arrow">
                        <img src={arrow}/>
                    </div>
                </div> */}
            </div>
        )
    }
}



const storesToProps = ({ store }: IStoresMap) => ({
    busket: store.BusketStore,
    configuratorStore: store.configuratorStore,
    anshlagStore: store.AnshlagStore
})

export default connector(storesToProps)(AnshlagFull)